"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_common_highlight_1 = require("@hotelplan/components.common.highlight");
const TravelDestinationLabel_1 = __importDefault(require("./TravelDestinationLabel"));
const TravelDestinationSuggestion = ({ item, query, }) => {
    return (react_1.default.createElement(TravelDestinationLabel_1.default, { item: item, label: react_1.default.createElement(components_common_highlight_1.HighlightText, { text: item.canonicalName, substring: query }) }));
};
exports.default = TravelDestinationSuggestion;
//# sourceMappingURL=TravelDestinationSuggestion.js.map